<template>
    <system-tabs :tabs="tabs">
        <template slot="help">
            <helpTable/>
            <helpBrowser/>
        </template>

        <template slot="w1">
            <interface-browser @event="onEvent" :tabs="browserTabs"/>
        </template>

        <template slot="w2">
            <div style="background-color: rgba(0, 0, 0, .1); padding: 10px">
                Группа 26/8. Австрия. Вена-Инсбрук-Мюнхен
            </div>
            <interface-table :headers="table.headers" :data="table.data" :search="false"></interface-table>
        </template>
    </system-tabs>
</template>

<script>
    import InterfaceBrowser from '@/components/interface/browser'
    import InterfaceTable from '@/components/interface/table'
    import SystemTabs from '@/components/system/tabs'
    import data from './_data'

    import helpBrowser from '@/components/interface/browser/help'
    import helpTable from '@/components/interface/table/help'


    export default {
        components: {
            InterfaceBrowser,
            InterfaceTable,
            SystemTabs,
            helpBrowser,
            helpTable
        },
        data () {
            return {
                actions: {
                    success: false
                },
                browserTabs: [{
                    title: 'МногоБилетов.ру',
                    url: '/mnogobiletov.ru'
                }],
                tabs: [
                    {
                        title: 'Web',
                        name: 'browser',
                        slot: 'w1'
                    },
                    {
                        title: 'Онлайн календарь',
                        name: 'table',
                        modifier: 'calendar',
                        slot: 'w2'
                    }
                ],
                table: data.table
            }
        },
        methods: {
            onEvent (event) {
                if (event.name === 'buy' && event.data.cart.length === 1) {
                    let item = event.data.cart[0]
                    if (item.tour.id === 405 && item.count === 15) {
                        this.actions.success = true
                    }
                }
                this.$store.dispatch('questions/answer', this.actions)
            },

            // Завершение теста
            // Выполнение необходимых действий перед
            // переходом к следующему заданию / этипу
            finish () {}
        }
    }
</script>
